const randomKey = () => (
  globalThis.crypto?.randomUUID?.() ||
  `request-${Date.now()}-${Math.random().toString(36).slice(2)}`
);

export const requestKeyFor = (requestRef, payload) => {
  const fingerprint = JSON.stringify(payload);
  if (!requestRef.current?.key || requestRef.current.fingerprint !== fingerprint) {
    requestRef.current = { key: randomKey(), fingerprint };
  }
  return requestRef.current.key;
};

export const resetRequestKey = (requestRef) => {
  requestRef.current = { key: "", fingerprint: "" };
};
